<template>
  <div class="course-select__container">
    <div 
      v-if="!attendableCourses"
      class="attandable-course-loading__container"
    >
      <el-spinner 
        :stroke-width="2"
      />
    </div>
    <div 
      v-else
      class="attandable-course-list__container"
    >
      <div 
        class="checkin-header"
      >
        <h1>
          환영합니다 {{ checkedMember.member.name }}님! <br>
          {{
            attendableCourses.length === 0 ?
              '현재 수강 가능한 수업이 없습니다.' : '수강할 수업을 선택해주세요.'
          }}
        </h1>

        <div
          class="checkin-description"
          v-html="attendableCourses.length === 0 ?
            '내일 다시 방문해주세요. <br> 5초후 메인 페이지로 이동됩니다.' : '이미 지난 수업은 출석체크가 불가합니다.'"
        />
      </div>

      <div class="checkin-scroll-container">
        <div class="checkin-action-container">
          <div
            v-for="course in attendableCourses"
            :key="course.id"
            class="checkin__child-course checkin-box press-animation"
            @click="handleClickCourse(course)"
          >
            <section class="contents-wrapper">
              <article>
                <span>{{ presentCourseTime(course) }}</span>
                <div class="vr">
                  |
                </div>
                <span>{{ presentInstructorNames(course) }}</span>
              </article>
              <article>
                <span>{{ course.parent_course.name }}</span>
              </article>
            </section>
            <div class="right-arrow" />
          </div>
        </div>
      </div>

      <audio ref="elErrorAudio">
        <source
          src="//cdn.fiflbox.com/admin/checkin/fiflbox_error.wav"
          type="audio/wav"
        >
      </audio>
    </div>
  </div>
</template>

<script>
import dateFns from 'date-fns';
import { mapGetters } from 'vuex';
import { computedGetters } from '../../utils/vuex-helper';
import { ATTEND_FAIL_MESSAGES } from '../../constants';

export default {
  name: 'CourseSelect',
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['getInstructorByIds']),
    ...computedGetters([
      'attendableCourses',
      'membershipSystem',
      'childMembershipForAttend',
      'checkedMember'
    ])
  },
  created() {
    if (this.childMembershipForAttend.id === null) {
      this.$router.replace('/checkin').catch(() => {});
    }
  },
  mounted() {
    if (this.attendableCourses.length === 0) {
      setTimeout(() => {
        if (this.$route.path === '/checkin/course') {
          this.$router.replace('/checkin').catch(() => {});
        }
      }, 5000);
    } else {
      setTimeout(() => {
        if (this.$route.path === '/checkin/course') {
          this.$router.replace('/checkin').catch(() => {});
        }
      }, 1000 * 30);
    }
  },
  methods: {
    presentCourseTime(course) {
      const endTime = dateFns.format(
        dateFns.addMinutes(course.start, course.duration),
        'HH:mm'
      );
      return `${dateFns.format(course.start, 'HH:mm')} - ${endTime}`;
    },
    presentInstructorNames(course) {
      return this.getInstructorByIds(course.instructors)
        .map(instructor => {
          return instructor ? instructor.name : null;
        })
        .filter(item => item)
        .join(', ');
    },
    async alert({ title, message }) {
      await this.$alert(message, title, {
        confirmButtonText: '확인',
        showClose: false,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white'
      });
    },
    async handleClickCourse(course) {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      try {
        await this.$store.dispatch('attendCourse', {
          childCourseId: course.id
        });

        this.$router.replace('/checkin/confirm').catch(() => {});
      } catch (err) {
        let errorCode = err.response.data.error_code;
        let errorMessage = ATTEND_FAIL_MESSAGES[errorCode];

        if (errorCode === '109') {
          errorMessage = {
            type: 'alert',
            title: `잔여 ${this.membershipSystem.long} 부족`,
            message: `본 수업 수강에 필요한 ${
              this.membershipSystem.long
            }가 부족합니다. 다른 수업을 선택하거나 회원권을 재등록해주시길 바랍니다.`
          };
        }

        if (errorMessage.type !== 'alert') {
          errorMessage.title = '출석체크 불가';
        }

        this.isLoading = false;
        this.$refs.elErrorAudio.play();
        this.alert(errorMessage);
      }
    }
  }
};
</script>

<style lang="scss">
.course-select__container {
  width: 100%;
  height: 100%;

  .attandable-course-loading__container {
    display: flex;
    width: 100%;
    height: 100%;
    .el-spinner {
      margin: auto;
    }
  }

  .attandable-course-list__container {
    height: 100%;
    display: flex;
    flex-direction: column;
    .checkin-header {
      flex: initial;
    }

    .checkin-scroll-container {
      flex: auto;
      overflow-y: auto;
    }
  }
}
</style>
